import React from 'react'

type Props = {
    className?: string
}

export const ListIcon = (props: Props) => {
    const { className = 'w-5 h-5' } = props
    return (
        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
            <path d="M3 5h.01"/>
            <path d="M3 12h.01"/>
            <path d="M3 19h.01"/>
            <path d="M8 5h13"/>
            <path d="M8 12h13"/>
            <path d="M8 19h13"/>
        </svg>
    )
}
